import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSparkles } from '@fortawesome/pro-regular-svg-icons'
import { QuestionChip } from 'components/ui/QuestionChip'
import { useSuggestedQuestions } from 'hooks/useSuggestedQuestions'

const DefaultQuestionsComponent = () => {
  const { t } = useTranslation()
  const { questions, visible, disabled, sendQuestion } = useSuggestedQuestions()

  if (!visible) return null

  return (
    <div className="tw-flex tw-flex-col tw-items-start tw-gap-2 tw-mt-4 tw-mb-2">
      <div
        className="tw-flex tw-items-center tw-gap-1.5 tw-text-xs tw-uppercase tw-tracking-wide tw-opacity-0"
        style={{ color: 'var(--text-tertiary)', animation: 'fade-slide-in 0.4s ease-out forwards' }}
      >
        <FontAwesomeIcon icon={faSparkles} className="tw-w-3 tw-h-3" style={{ color: 'var(--brand-text)' }} />
        <span>{t('suggestedQuestions')}</span>
      </div>
      {questions.map((question, index) => (
        <QuestionChip
          key={question}
          question={question}
          disabled={disabled}
          onClick={() => sendQuestion(question)}
          animationDelayMs={100 + index * 80}
        />
      ))}
    </div>
  )
}

export const DefaultQuestions = memo(DefaultQuestionsComponent)
DefaultQuestions.displayName = 'DefaultQuestions'
